import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCloseMenu = () => {
    setIsOpen(false);
  };

  const NavLinks = ({ onClick, className = "" }) => (
    <>
      <Link
        to="/"
        onClick={onClick}
        className={`${className} text-sm text-gray-700 hover:text-[#002b5b]`}
      >
        トップ
      </Link>
      <Link
        to="/contact"
        onClick={onClick}
        className={`${className} text-sm text-gray-700 hover:text-[#002b5b]`}
      >
        お問い合わせ
      </Link>
      <Link
        to="/wizard"
        onClick={onClick}
        className={`${className} text-sm text-gray-700 hover:text-[#002b5b]`}
      >
        診断スタート
      </Link>
      <Link
        to="/about"
        onClick={onClick}
        className={`${className} text-sm text-gray-700 hover:text-[#002b5b]`}
      >
        当社について
      </Link>
    </>
  );

  return (
    <header className="w-full bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <Link to="/" className="inline-flex items-center">
            <img className="w-32 md:w-40" src="/images/camarago_letter_logo.png" alt="camarago" />
          </Link>

          {/* PCナビゲーション */}
          <nav className="hidden md:flex space-x-6">
            <NavLinks />
          </nav>

          {/* ハンバーガーメニュー（モバイル） */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 focus:outline-none"
              aria-label="Toggle menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* モバイルナビゲーション（縦並び） */}
      {isOpen && (
        <div className="md:hidden px-4 pb-4 space-y-2 flex flex-col">
          <NavLinks onClick={handleCloseMenu} className="block" />
        </div>
      )}
    </header>
  );
};

export default Header;
